import React from "react";
import PropTypes from "prop-types";

const ChatMessage = ({ message }) => {
  const isUser = message.type === "user";

  return (
    <div className={`flex ${isUser ? "justify-end" : "justify-start"} mb-4`}>
      <div
        className={`max-w-xs rounded-25px px-4.5 py-2.5 lg:max-w-md ${
          isUser ? "bg-green-12 text-white" : "bg-grey-18 text-black-9"
        }`}
      >
        <p className="whitespace-pre-wrap text-ft14-19.6">{message.content}</p>
        {message.timestamp && (
          <span className="mt-1 block text-ft12-16 opacity-60">
            {new Date(message.timestamp).toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit"
            })}
          </span>
        )}
      </div>
    </div>
  );
};

ChatMessage.propTypes = {
  message: PropTypes.shape({
    id: PropTypes.string.isRequired,
    type: PropTypes.oneOf(["user", "system"]).isRequired,
    content: PropTypes.string.isRequired,
    timestamp: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.instanceOf(Date)
    ])
  }).isRequired
};

export default ChatMessage;
